export enum InvoiceGovernmentType {
  UNION = 'UNION',
  ESTATE = 'ESTATE',
  FEDERAL_DISTRICT = 'FEDERAL_DISTRICT',
  MUNICIPALITY = 'MUNICIPALITY',
  // NT 2025.002 (BB02) - novos entes. Valores string a alinhar com o back.
  PUBLIC_CONSORTIUM = 'PUBLIC_CONSORTIUM',
  IBS_MANAGEMENT_COMMITTEE = 'IBS_MANAGEMENT_COMMITTEE',
}

export const InvoiceGovernmentTypeLabel: Record<InvoiceGovernmentType, string> =
  {
    UNION: '1 - União',
    ESTATE: '2 - Estado',
    FEDERAL_DISTRICT: '3 - Distrito Federal',
    MUNICIPALITY: '4 - Município',
    PUBLIC_CONSORTIUM: '5 - Consórcio Público',
    IBS_MANAGEMENT_COMMITTEE: '6 - Comitê Gestor do IBS',
  };

export enum InvoiceGovernmentOperation {
  SUPPLY = 'SUPPLY',
  RECEIPT = 'RECEIPT',
  // NT 2025.002 (BB04) - novas operações. Valores string a alinhar com o back.
  SUPPLY_ALREADY_PAID = 'SUPPLY_ALREADY_PAID',
  RECEIPT_LATER_SUPPLY = 'RECEIPT_LATER_SUPPLY',
}

export const InvoiceGovernmentOperationLabel: Record<
  InvoiceGovernmentOperation,
  string
> = {
  SUPPLY: '1 - Fornecimento com pagamento posterior',
  RECEIPT: '2 - Recebimento do pagamento com fornecimento já realizado',
  SUPPLY_ALREADY_PAID: '3 - Fornecimento com pagamento já realizado',
  RECEIPT_LATER_SUPPLY: '4 - Recebimento do pagamento com fornecimento posterior',
};

// NT 2025.002 (B25.1) - Tipo de Nota de Débito (tpNFDebito)
export enum InvoiceDebitNoteType {
  CREDIT_TRANSFER_TO_COOPERATIVES = 'CREDIT_TRANSFER_TO_COOPERATIVES',
  CREDIT_CANCELLATION_EXEMPT_OR_NON_TAXABLE_OUTPUTS = 'CREDIT_CANCELLATION_EXEMPT_OR_NON_TAXABLE_OUTPUTS',
  DEBITS_OF_INVOICES_NOT_PROCESSED_IN_TAX_ASSESSMENT = 'DEBITS_OF_INVOICES_NOT_PROCESSED_IN_TAX_ASSESSMENT',
  FINE_AND_INTEREST = 'FINE_AND_INTEREST',
  CREDIT_TRANSFER_IN_SUCCESSION = 'CREDIT_TRANSFER_IN_SUCCESSION',
  ADVANCE_PAYMENT = 'ADVANCE_PAYMENT',
  STOCK_LOSS = 'STOCK_LOSS',
  SIMPLES_NACIONAL_DISENROLLMENT = 'SIMPLES_NACIONAL_DISENROLLMENT',
}

export const InvoiceDebitNoteTypeLabel: Record<InvoiceDebitNoteType, string> = {
  CREDIT_TRANSFER_TO_COOPERATIVES:
    '01 - Transferência de créditos para Cooperativas',
  CREDIT_CANCELLATION_EXEMPT_OR_NON_TAXABLE_OUTPUTS:
    '02 - Anulação de Crédito por Saídas Imunes/Isentas',
  DEBITS_OF_INVOICES_NOT_PROCESSED_IN_TAX_ASSESSMENT:
    '03 - Débitos de notas fiscais não processadas na apuração',
  FINE_AND_INTEREST: '04 - Multa e juros',
  CREDIT_TRANSFER_IN_SUCCESSION: '05 - Transferência de crédito na sucessão',
  ADVANCE_PAYMENT: '06 - Pagamento antecipado',
  STOCK_LOSS: '07 - Perda em estoque (Perecimento, Perda, Furto, Roubo)',
  SIMPLES_NACIONAL_DISENROLLMENT: '08 - Desenquadramento do SN',
};

// NT 2025.002 (B25.2) - Tipo de Nota de Crédito (tpNFCredito)
export enum InvoiceCreditNoteType {
  FINE_AND_INTEREST = 'FINE_AND_INTEREST',
  PRESUMED_IBS_CREDIT_ZFM = 'PRESUMED_IBS_CREDIT_ZFM',
  RETURN_DUE_TO_TOTAL_REFUSAL_OR_RECIPIENT_NOT_LOCATED = 'RETURN_DUE_TO_TOTAL_REFUSAL_OR_RECIPIENT_NOT_LOCATED',
  VALUE_REDUCTION = 'VALUE_REDUCTION',
  CREDIT_TRANSFER_IN_SUCCESSION = 'CREDIT_TRANSFER_IN_SUCCESSION',
  RETURN_DUE_TO_PARTIAL_REFUSAL = 'RETURN_DUE_TO_PARTIAL_REFUSAL',
}

export const InvoiceCreditNoteTypeLabel: Record<InvoiceCreditNoteType, string> =
  {
    FINE_AND_INTEREST: '01 - Multa e juros',
    PRESUMED_IBS_CREDIT_ZFM:
      '02 - Apropriação de crédito presumido de IBS sobre o saldo devedor na ZFM',
    RETURN_DUE_TO_TOTAL_REFUSAL_OR_RECIPIENT_NOT_LOCATED:
      '03 - Retorno por recusa total na entrega ou não localização do destinatário',
    VALUE_REDUCTION: '04 - Redução de valores',
    CREDIT_TRANSFER_IN_SUCCESSION: '05 - Transferência de crédito na sucessão',
    RETURN_DUE_TO_PARTIAL_REFUSAL: '06 - Retorno por recusa parcial na entrega',
  };
